import { buildCompositeKey } from "../utils/compositeKey";
import type { DataRow } from "../types";

export function collectGroupInfo(
  data: DataRow[],
  groupBy: string[],
): {
  distinctGroupCombinations: string[];
  groupByKey: Record<string, any[]>;
  groupKeysByRow: string[];
} {
  const distinctGroupCombinations: string[] = [];
  const seenGroupCombinations = new Set<string>();
  const dataLength = data.length;
  const groupKeysByRow = new Array<string>(dataLength);
  const groupByCount = groupBy.length;
  const groupBySets: Record<string, Set<any>> = {};

  for (let gIndex = 0; gIndex < groupByCount; gIndex += 1) {
    groupBySets[groupBy[gIndex]] = new Set<any>();
  }

  for (let rowIndex = 0; rowIndex < dataLength; rowIndex += 1) {
    const row = data[rowIndex];
    const groupKey = buildCompositeKey(row, groupBy);
    groupKeysByRow[rowIndex] = groupKey;

    if (!seenGroupCombinations.has(groupKey)) {
      seenGroupCombinations.add(groupKey);
      distinctGroupCombinations.push(groupKey);
    }

    for (let gIndex = 0; gIndex < groupByCount; gIndex += 1) {
      const key = groupBy[gIndex];
      groupBySets[key].add(row[key]);
    }
  }

  const groupByKey: Record<string, any[]> = {};
  for (let gIndex = 0; gIndex < groupByCount; gIndex += 1) {
    const key = groupBy[gIndex];
    groupByKey[key] = Array.from(groupBySets[key]);
  }

  // Globally stabilize the order of group combinations so that index-based colors stay consistent
  distinctGroupCombinations.sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base", numeric: true }),
  );

  return {
    distinctGroupCombinations,
    groupByKey,
    groupKeysByRow,
  };
}
